import { useQuery, type UseQueryOptions } from '@tanstack/react-query';
import api from 'modules/queries/api';
import {
	type LWApiPublicProductDetailsParamsRawI,
	type LWApiPublicProductDetailsResultRawI,
} from '@liquidweb-dev/club-sauce/public/product/index.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';

export const PRODUCT_DETAILS_QUERY_KEY = '/product/details';

/** @deprecated prefer using the `/product/flatDetails` api method */
const useProductDetails = (
	params: LWApiPublicProductDetailsParamsRawI,
	options?: UseQueryOptions<LWApiPublicProductDetailsResultRawI, ApiErrorI>,
) =>
	useQuery({
		queryKey: [PRODUCT_DETAILS_QUERY_KEY, params],
		queryFn: () => api.product.apiRaw.details(params),
		staleTime: 10 * 60 * 1000,
		...options,
	});

export default useProductDetails;
